import { FormAddress, FormAddressSchema } from "src/schemas/Address";

type GoogleAddressComponents = {
  street_number?: string;
  route?: string; // Street
  // neighborhood?: string;
  locality?: string; // City
  // administrative_area_level_2?: string; // County
  administrative_area_level_1?: string; // State
  // country?: string;
  postal_code?: string;
  // postal_code_suffix?: string;
  subpremise?: string; // Street address line 2
};

export function toFormAddress(
  googleComponentArray: google.maps.GeocoderAddressComponent[],
  location?: google.maps.LatLng
): FormAddress {
  // Convert array to an object mapping each component's primary `type` to its value.
  const googleComponents: GoogleAddressComponents = Object.fromEntries(
    googleComponentArray.map(({ short_name, types }) => [types[0], short_name])
  );

  let street_address = undefined;
  if (googleComponents.street_number || googleComponents.route) {
    street_address = `${googleComponents.street_number ?? ""} ${
      googleComponents.route ?? ""
    }`.trim();
  }

  return FormAddressSchema.parse({
    street_address: street_address ?? "",
    street_address_line_2: googleComponents.subpremise ?? "",
    city: googleComponents.locality ?? "",
    state: googleComponents.administrative_area_level_1 ?? "",
    zip_code: googleComponents.postal_code ?? "",
    geom: location ? { coordinates: [location.lng(), location.lat()] } : null,
  });
}
